export default __webpack_public_path__ + "static/media/018.19a577b8.jpg";